__turbopack_context__.v({
  "actionButton": "base-module-scss-module__MxbICq__actionButton",
  "lgContainer": "base-module-scss-module__MxbICq__lgContainer",
  "mdContainer": "base-module-scss-module__MxbICq__mdContainer",
  "narrowContainer": "base-module-scss-module__MxbICq__narrowContainer",
  "secondaryBtn": "base-module-scss-module__MxbICq__secondaryBtn",
  "sectionDescription": "base-module-scss-module__MxbICq__sectionDescription",
  "sectionTitle": "base-module-scss-module__MxbICq__sectionTitle",
});
